import { useAppContext } from '@store';
import { I18n, TranslateOptions } from 'i18n-js';
import cs from './cs.json';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import it from './it.json';

const i18n = new I18n({ en });
i18n.enableFallback = true;

export type TranslationKey = keyof typeof en;
export type SupportedLocale = 'en' | 'fr' | 'de' | 'it' | 'es' | 'cs';
export type SupportedLanguage = {
  name: string;
  locale: SupportedLocale;
};

const languages: SupportedLanguage[] = [
  { name: 'English', locale: 'en' },
  { name: 'Français', locale: 'fr' },
  { name: 'Deutsch', locale: 'de' },
  // { name: 'Indonesian', locale: 'id' },
  { name: 'Italiano', locale: 'it' },
  // { name: 'Japanese', locale: 'ja' },
  // { name: 'Chinese (Simplified)', locale: 'zh' },
  { name: 'Español', locale: 'es' },
  { name: 'Čeština', locale: 'cs' },
];

const translations = { cs, de, en, es, fr, it };

const translate = (scope: TranslationKey, options?: TranslateOptions) => {
  return i18n.t(scope, options);
};

export const useLocalization = () => {
  const { locale } = useAppContext();

  if (i18n.locale !== locale && translations[locale]) {
    i18n.locale = locale;
    i18n.store({ [locale]: translations[locale] });
  }

  return {
    t: translate,
    languages,
  };
};

export default useLocalization;
